(() => {
  const closeMenus = () => document.querySelectorAll('.bg-mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  document.addEventListener('click', event => {
    const link = event.target.closest('.bg-mobile-links a');
    if (link) closeMenus();
    document.querySelectorAll('.bg-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenus(); });
})();
